import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-slate-500 hover:text-slate-800 mb-8 text-sm"
          data-testid="terms-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>

        <h1 className="text-3xl font-bold text-slate-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-slate-500 mb-10">Last Updated: September 11, 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-[15px] leading-relaxed text-slate-700">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>By accessing or using the FieldReady application, you agree to be bound by these Terms of Service. If you do not agree, do not use the application.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">2. About This Application</h2>
            <p>FieldReady is operated by Center Line Locating, LLC ("CLL"), a North Carolina limited liability company. It is an internal job scheduling and field management tool for authorized CLL personnel.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">3. Access and Acceptable Use</h2>
            <p>Access to FieldReady is granted solely by CLL and may be revoked at any time. You agree to use this application only for authorized CLL business purposes. You may not share your login credentials, access the application on behalf of any third party, or use it for any purpose outside your role at CLL.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">4. Data Ownership</h2>
            <p>All data entered into FieldReady — including job records, time entries, field reports, uploaded files, and GPS location data — is the property of Center Line Locating, LLC. Upon termination of your access, CLL retains all data entered during your use of the application.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">5. GPS and Location Tracking</h2>
            <p>By using the Time Tracker features of this application, you acknowledge that your GPS location may be recorded during active time entries. This data is used solely for job management and payroll purposes as described in the Privacy Policy.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">6. No Warranty</h2>
            <p>The application is provided "as is" without warranties of any kind. CLL does not warrant that the application will be uninterrupted or error-free.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">7. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, CLL shall not be liable for any indirect, incidental, or consequential damages arising from your use of this application. Our total liability for any claim shall not exceed one hundred U.S. dollars ($100).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">8. Intellectual Property</h2>
            <p>All content, design, and functionality of FieldReady is the property of Center Line Locating, LLC and is protected by applicable intellectual property laws.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">9. Governing Law</h2>
            <p>These Terms shall be governed by the laws of the State of North Carolina. Any disputes shall be resolved exclusively in the state or federal courts of Mecklenburg County, North Carolina.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">10. Changes to These Terms</h2>
            <p>CLL may update these Terms at any time. Continued use of the application after changes constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">11. Contact</h2>
            <div className="mt-3 bg-slate-50 rounded-lg p-4 text-sm">
              <p className="font-semibold text-slate-900">Center Line Locating, LLC</p>
              <p>12030 Goodrich Drive, Charlotte, NC 28273</p>
              <p className="mt-2">Email: <a href="mailto:requests@cllocating.com" className="text-blue-600 hover:underline">requests@cllocating.com</a></p>
              <p>Phone: <a href="tel:+17043155820" className="text-blue-600 hover:underline">(704) 315-5820</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
